import React, { Component } from 'react';
import { connect } from 'react-redux';
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';
import { setDeviceTagCategory, setDeviceEmpty } from "../../../testActions";
import { store } from "../../../testStore";
import { withRouter } from 'react-router-dom';
import { S, domainIsTenant } from '../../../routes/routes';

import { buildWBoundActions, buildWSelector } from '../../../redux/ducks'
import { actions as notificationActions } from '../../../redux/ducks/notification'
import { actions as modalActions } from '../../../redux/ducks/modal'

import { SubViewHeader } from '../../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { upperFirstLetter } from '../../../lib/components/formatter';
import { isEmpty } from 'iotera-base/object';
import Result from 'iotera-base/result';
import { IoteraForm } from '../../../lib/components/form';
import './style.scss'

/* React Confirm Alert */
import { ioteraConfirmAlert } from '../../../lib/components/react/react-confirm-alert';

import { setCallbackGlobal, unsetCallbackGlobal } from '../../../lib/components/callbackGlobal';

const WKEY = "EDIT_TAG_CAT";
const INIT_TAGS = "INIT_TAGS";
const INIT_DEV = "INIT_DEV";
const EDIT = "EDIT_TAG";
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

function schema(properties) {
  return {
    title: "Pilih kategori yang akan dipakai untuk perangkat",
    type: "object",
    required: [],
    properties
  }
};

function Tpl(props) {
  const { id, children, errors } = props;
  return (
    <div className="myfield">
      <label htmlFor={id}></label>
      {children}
      {errors}
    </div>
  );
}

class Example extends Component {
  constructor(props) {
    super(props)
    const deviceId = safeDeepGet(props, ['match', 'params', 'id']);
    const data = safeDeepGetWithType(props, ['device'], {});
    this.state = {
      value: [],
      formData: data,
      values: '',
      deviceId,
      loading: false,
      prevPath: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onFormChange = this.onFormChange.bind(this);
  }

  componentDidMount() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const deviceId = safeDeepGet(_props, ['match', 'params', 'id']);
    if (isEmpty(deviceId)) {
      return {}
    }
    const wsKey = WKEY + '_' + deviceId;
    const dit = domainIsTenant(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        requests: {
          [INIT_TAGS]: {
            wparam: { ...dit, path: "/service/web/tag/category/get/all" },
            wcallback: {
              started: function (id) {
                // TODO Loading
              },
              finished: function (id, result) {
                // TODO Loading
                _this.setState({
                  loading: false,
                  tags: safeDeepGetWithType(result, ['body', 'categories'], {})
                })
              },
            }
          },
          [INIT_DEV]: {
            wparam: { ...dit, path: "/service/web/device/get/id/" + deviceId },
            wcallback: {
              started: function (id) {
                // TODO Loading
              },
              finished: function (id, result) {
                // TODO Loading
                _this.setState({
                  loading: false
                })
              }
            },
            wreducer: {
              rparse: function (id, result, rpayload) {
                let device = rpayload;
                let deviceTemp = {};
                let ids = device["id"];
                deviceTemp.__id = ids;
                deviceTemp.tags = device["tags"];
                _this.setState({
                  formData: deviceTemp
                })
                return deviceTemp;
              }
            }
          }
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [EDIT]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/device/edit"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false
                  })
                  _props.history.push('..' + S + '..' + S + '_device_list_')
                  _props.showSingleNotification({ message: 'Edit Perangkat Sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Edit Perangkat Gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }


  componentWillUnmount() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { deviceId } = _state;
    if (isEmpty(deviceId)) {
      return {}
    }
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  componentWillReceiveProps(nextProps) {
    const _this = this
    const _props = _this.props
    if (nextProps.location !== _props.location) {
      _this.setState({ prevPath: _props.location })
    }
  }

  handleSubmit(event) {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let dataToSubmit = event.formData;
    let final = [];
    for (let key in dataToSubmit) {
      if (dataToSubmit.hasOwnProperty(key)) {
        let data = dataToSubmit[key];
        if (data === true) {
          final.push(key)
        }
      }
    }
    let action = setDeviceTagCategory(final);
    store.dispatch(action)
    const id = safeDeepGet(_props, ['deviceId']);
    if (final.length === 0) {
      const wsKey = WKEY + '_' + id;
      ioteraConfirmAlert(
        'Simpan Penanda',
        'Tidak ada penanda yang dipilih!\nYakin akan menyimpan konfigurasi perangkat tanpa penanda?',
        null,
        () => _props.wSingleRequestCall({
          id: EDIT,
          body: {
            id,
            tags: {}
          }
        }),
        null,
        null
      )
    } else {
      _props.history.push('..' + S + 'tag' + S + _state.deviceId)
    }
  }

  goTo(link) {
    this.props.history.push(link)
  }

  goBack() {
    let action = setDeviceEmpty();
    store.dispatch(action)
    this.props.history.goBack();
  };

  onFormChange(event) {
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const tags = safeDeepGetWithType(_props, ['items'], {});
    const data = safeDeepGetWithType(_props, ['device'], {});
    let dataToShow = data;
    let propertiesSchema = {}
    let propertiesUiSchema = {}
    for (let core in tags) {
      let item = tags[core];
      let itemPrefix = item.prefix;
      let itemName = upperFirstLetter(item.name);
      let itemCat = item.category;
      if (itemCat === 1) {
        let itemDef = item.definitions;
        if (itemDef.length === 0) {
          continue;
        }
      }
      Object.assign(propertiesSchema, {
        [itemPrefix]: {
          title: itemName,
          'type': 'boolean'
        }
      })
      Object.assign(propertiesUiSchema, {
        [itemPrefix]: {
          "ui:options": {
            label: false
          }
        }
      })
    }
    let deviceTags = safeDeepGetWithType(dataToShow, ['tags'], {});
    let storeValue = store.getState();
    if (!isEmpty(storeValue)) {
      if ('device' in storeValue) {
        if (!isEmpty(storeValue.device)) {
          storeValue = { ...storeValue.device };
        }
      }
    }
    let tagCheck = safeDeepGetWithType(storeValue, ['tag_cat'], []);
    for (let i = 0; i < tagCheck.length; i++) {
      Object.assign(dataToShow, {
        [tagCheck[i]]: true
      })
    }
    if (tagCheck.length < 1) {
      for (let key in deviceTags) {
        if (deviceTags.hasOwnProperty(key)) {
          Object.assign(dataToShow, {
            [key]: true
          })
        }
      }
    }
    return (
      <div className="view">
        <SubViewHeader title='Edit Perangkat' subTitle='Permohonan edit penanda dari perangkat' />
        <div className="io-container mt-12">
          <IoteraForm
            schema={schema(propertiesSchema)}
            FieldTemplate={Tpl}
            formData={dataToShow}
            onSubmit={_this.handleSubmit}
          >
            <div className="button-right" style={{ marginTop: 10 }}>
              <Button variant="outlined" size="large" style={{ minWidth: '0%' }} onClick={() => _this.goBack()} >Batal</Button>
              <Button variant="contained" size="large" color="primary" type="submit"
                style={{ marginLeft: 10, minWidth: '0%' }}>Berikutnya</Button>
            </div>
          </IoteraForm>
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    device: wSelector.getMappedRPayload(state, INIT_DEV),
    deviceId: wSelector.getMappedRPayload(state, INIT_DEV, '__id'),
    items: wSelector.getMappedRPayload(state, INIT_TAGS, 'categories')
  }
}

const mapDispatchToProps = (dispatch) => ({
  ...wBoundActions(dispatch),
  ...bindActionCreators(notificationActions, dispatch),
  ...bindActionCreators(modalActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Example));